import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import ITextBuilder from "../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import IDateBuilder from "../../../toolkit/baseForms2/iDateBuilder/IDateBuilder";
import ISelectBuilder from "../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import ICheckBuilder from "../../../toolkit/baseForms2/iCheckBuilder/ICheckBuilder";
import { commonRegex } from "../../helpers/commonRegex";

export type Inputs =
  | "tipoBusqueda"
  | "idPersona"
  | "curp"
  | "paramCurp"
  | "nombre"
  | "paramNombre"
  | "soloExternos"
  | "fechaNacimiento";
export type Buttons = "buscar";

// const hideIfPredicate = (predicate: (values: any) => boolean) => ({ hidden: predicate });
const hiddenIfNotNombre = (values: any) => !!values.tipoBusqueda;
const hiddenIfNotId = (values: any) => values.tipoBusqueda !== "ID";
const hiddenIfNotCurp = (values: any) => values.tipoBusqueda !== "CURP";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "tipoBusqueda",
      label: "* Tipo de búsqueda",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Por Nombre",
        data: [
          { value: "ID", label: "Por Persona Id" },
          { value: "CURP", label: "Por CURP" }
        ]
      }
    },
    {
      name: "idPersona",
      label: "Id de Persona",
      bts: { mCol: 2 },
      component: ITextBuilder,
      props: {
        type: "NUMERIC",
        hidden: hiddenIfNotId
      }
    },
    {
      name: "curp",
      label: "CURP",
      bts: { mCol: 3 },
      component: ITextBuilder,
      props: {
        uppercase: true,
        maxlength: 18,
        hidden: hiddenIfNotCurp
      }
    },
    {
      name: "paramCurp",
      label: "Filtrado CURP",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Igual a",
        data: [{ value: "STARTS", label: "Comienza con" }],
        hidden: hiddenIfNotCurp
      }
    },
    {
      name: "nombre",
      label: "Nombre",
      bts: { mCol: 5 },
      component: ITextBuilder,
      props: {
        hidden: hiddenIfNotNombre,
        uppercase: true
      }
    },
    {
      name: "paramNombre",
      label: "El nombre",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Comienza con",
        data: [{ value: "CONTAINS", label: "Contiene" }],
        hidden: hiddenIfNotNombre
      }
    },
    {
      name: "soloExternos",
      label: "Mostrar solo externos",
      bts: { mCol: 2, mOff: 7 },
      component: ICheckBuilder,
      props: {
        hidden: hiddenIfNotNombre
      }
    },
    {
      name: "fechaNacimiento",
      label: "Fecha de nacimiento",
      bts: { mCol: 3 },
      component: IDateBuilder,
      props: {
        hidden: hiddenIfNotNombre
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    }
  ],
  validations: {
    idPersona: {
      requiredIfId: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "ID" && !value,
        message: () => "Campo obligatorio"
      }
    },
    curp: {
      requiredIfCurp: {
        validator: (value, formValue) =>
          formValue.tipoBusqueda === "CURP" && !value,
        message: () => "Campo obligatorio"
      },
      curpRegex: {
        validator: (value: string, formValue: any) =>
          value &&
          formValue.tipoBusqueda === "CURP" &&
          !formValue.paramCurp &&
          !commonRegex.curp.test(value.toUpperCase()),
        message: () => "La CURP ingresada no es válida",
        partners: ["paramCurp"]
      }
    },
    nombre: {
      requiredIfNombre: {
        validator: (value, formValue) => !formValue.tipoBusqueda && !value,
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [
    [
      "tipoBusqueda",
      "idPersona",
      "paramCurp",
      "curp",
      "paramNombre",
      "nombre",
      "fechaNacimiento",
      "soloExternos",
      "buscar"
    ]
  ]
};
